'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormInput = require('../FormInput');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { saveAddressDetails } from '../../actions/addressForm'

var StreetHousenumberAddressField = function (_React$Component) {
  (0, _inherits3.default)(StreetHousenumberAddressField, _React$Component);

  function StreetHousenumberAddressField(props) {
    (0, _classCallCheck3.default)(this, StreetHousenumberAddressField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StreetHousenumberAddressField.__proto__ || (0, _getPrototypeOf2.default)(StreetHousenumberAddressField)).call(this, props));

    _this.state = {
      street: '',
      housenumber: ''
    };


    var s = props.address || '';

    var m = s.match(/^(.*)\s+(\d{1,6}-?\w{0,5})$/);
    _this.state.street = m ? m[1] : s;
    _this.state.housenumber = m ? m[2] : '';
    return _this;
  }

  (0, _createClass3.default)(StreetHousenumberAddressField, [{
    key: 'handleChange',
    value: function handleChange(o) {
      var _this2 = this;

      this.setState(o, function () {
        return _this2.props.onChange && _this2.props.onChange(_this2.value);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          prefix = _props.prefix,
          _props$errors = _props.errors,
          errors = _props$errors === undefined ? {} : _props$errors,
          name = _props.name,
          id = _props.id;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_FormInput.Input, {
          type: 'hidden',
          id: id,
          name: name,
          value: this.state.street + ' ' + this.state.housenumber,
          required: true
        }),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--shn-street',
            inputName: prefix + 'AddressStreet',
            errors: errors,
            inputLabel: t('spree.street'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressStreet',
            value: this.state.street,
            onChange: function onChange(e) {
              return _this3.handleChange({ street: e.target.value });
            },
            required: true
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--shn-housenumber',
            inputName: prefix + 'AddressHousenumber',
            errors: errors,
            inputLabel: t('spree.housenumber'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressHousenumber',
            value: this.state.housenumber,
            onChange: function onChange(e) {
              return _this3.handleChange({ housenumber: e.target.value });
            },
            required: true,
            pattern: '^\\d{1,6}-?\\w{0,5}$'
          })
        )
      );
    }
  }, {
    key: 'value',
    get: function get() {
      return this.state.street + ' ' + this.state.housenumber;
    }
  }]);
  return StreetHousenumberAddressField;
}(_react2.default.Component);

exports.default = StreetHousenumberAddressField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/StreetHousenumberField.js
// module id = 531
// module chunks = 0